module.exports = __webpack_public_path__ + "static/media/arrowupward.0eb99b8a.svg";